<h2 *ngIf="data.type === SCREEN.dispatch" mat-dialog-title>
  <mat-icon *ngIf="successfulWithWarningNoError(); else matIconElse" class="text-success">check_circle</mat-icon>
  {{header}}

  <ng-template #matIconElse>
    <mat-icon *ngIf="dispatchResults.fullyError" color="warn">cancel</mat-icon>
    <mat-icon *ngIf="!dispatchResults.fullyError" class="text-warning">warning</mat-icon>
  </ng-template>
</h2>
<h2 *ngIf="data.type === SCREEN.onHold" mat-dialog-title>
  {{header}}
</h2>
<mat-dialog-content class="mat-typography">
  <mat-tab-group *ngIf="dispatchResults; else onHoldBlock" animationDuration="0ms">
    <!--    Dispatch block  -->
    <mat-tab [label]="futureDispatchLabel" *ngIf="dispatchResults.futureDispatchList.length > 0">
      <p>{{futureDispatchText}}</p>
      <span
        *ngFor="let futureRemito of dispatchResults.futureDispatchList">
        {{futureRemito}}<br>
      </span>
    </mat-tab>
    <mat-tab [label]="existingDispatchLabel" *ngIf="dispatchResults.existingDispatchDateList.length > 0">
      <p>{{existingDispatchText}}</p>
      <span
        *ngFor="let existingDispatchDate of dispatchResults.existingDispatchDateList">
        {{existingDispatchDate}}<br>
      </span>
    </mat-tab>
    <mat-tab [label]="canceledLabel" *ngIf="dispatchResults.canceledRemitoList.length > 0">
      <span
        *ngFor="let canceledRemito of dispatchResults.canceledRemitoList">
        {{canceledRemito}}<br>
      </span>
    </mat-tab>
    <mat-tab [label]="combinationNotFoundLabel" *ngIf="dispatchResults.notFoundRemitoList.length > 0">
        <span
          *ngFor="let notFoundRemito of dispatchResults.notFoundRemitoList; let i = index">
          {{notFoundRemito}}<br>
        </span>
    </mat-tab>
  </mat-tab-group>

  <!--  On hold block -->
  <ng-template #onHoldBlock>
    <mat-tab-group animationDuration="0ms">
      <!--    OnHold block  -->
      <mat-tab [label]="vinNotFoundLabel" *ngIf="onHoldResults.notFoundVinList.length > 0">
        <span *ngFor="let notFoundVin of onHoldResults.notFoundVinList; let i = index">
          {{notFoundVin}}
          &nbsp;  <!--Empty spaces -->
          <br *ngIf="(i+1)%3==0"> <!--Add a new line every 3 vins-->
        </span>
      </mat-tab>
      <mat-tab [label]="releaseOnHoldErrorLabel" *ngIf="onHoldResults.processingError.length > 0">
        <p *ngFor="let error of onHoldResults.processingError">
          {{error}}
        </p>
        &nbsp;  <!--Empty spaces -->
      </mat-tab>
    </mat-tab-group>
  </ng-template>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button mat-dialog-close>
    Close
  </button>
</mat-dialog-actions>
